import NotificationBar from './NotificationBar.component';

export default NotificationBar;
